"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaxEventSource = void 0;

var WaxEventSource = /*#__PURE__*/function () {
  function WaxEventSource(waxSigningURL) {
    var _this = this;

    _classCallCheck(this, WaxEventSource);

    this.waxSigningURL = waxSigningURL;

    this.timeout = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (_, reject) {
                  return setTimeout(function () {
                    return reject(new Error("Timeout"));
                  }, 5000);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };

    this.openEventSource = this.openEventSource.bind(this);
    this.onceEvent = this.onceEvent.bind(this);
  }

  _createClass(WaxEventSource, [{
    key: "openPopup",
    value: function openPopup(url) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var win;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return window.open(url, "WaxPopup", "height=800,width=600");

              case 2:
                win = _context2.sent;

                if (!win) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", win);

              case 5:
                throw new Error("Unable to open popup window");

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "openEventSource",
    value: function openEventSource(url, message, win) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var openedWindow, postTransaction, eventPromise;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!win) {
                  _context4.next = 4;
                  break;
                }

                _context4.t0 = win;
                _context4.next = 7;
                break;

              case 4:
                _context4.next = 6;
                return this.openPopup(url);

              case 6:
                _context4.t0 = _context4.sent;

              case 7:
                openedWindow = _context4.t0;

                if (openedWindow) {
                  _context4.next = 10;
                  break;
                }

                throw new Error("Unable to open a popup window");

              case 10:
                if (!(typeof message === "undefined")) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt("return", openedWindow);

              case 12:
                postTransaction = function postTransaction(event) {
                  return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (event.data.type === "READY") {
                              openedWindow.postMessage(message, this.waxSigningURL);
                            }

                          case 1:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this);
                  }));
                };

                eventPromise = this.onceEvent(openedWindow, this.waxSigningURL, postTransaction, "READY");
                _context4.next = 16;
                return Promise.race([eventPromise, this.timeout()]).catch(function (err) {
                  if (err.message !== "Timeout") {
                    throw err;
                  }

                  openedWindow.postMessage(message, _this2.waxSigningURL);
                });

              case 16:
                return _context4.abrupt("return", openedWindow);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "onceEvent",
    value: function onceEvent(source, origin, action, type) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", new Promise(function (resolve, reject) {
                  var resolved = false;
                  window.addEventListener("message", function onEvent(event) {
                    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (!(event.origin !== origin)) {
                                _context5.next = 2;
                                break;
                              }

                              return _context5.abrupt("return");

                            case 2:
                              if (!(event.source !== source)) {
                                _context5.next = 4;
                                break;
                              }

                              return _context5.abrupt("return");

                            case 4:
                              if (!(typeof event.data !== "object")) {
                                _context5.next = 6;
                                break;
                              }

                              return _context5.abrupt("return");

                            case 6:
                              if (!(type && (!event.data.type || event.data.type !== type))) {
                                _context5.next = 8;
                                break;
                              }

                              return _context5.abrupt("return");

                            case 8:
                              _context5.prev = 8;
                              resolved = true;
                              _context5.t0 = resolve;
                              _context5.next = 13;
                              return action(event);

                            case 13:
                              _context5.t1 = _context5.sent;
                              (0, _context5.t0)(_context5.t1);
                              _context5.next = 21;
                              break;

                            case 17:
                              _context5.prev = 17;
                              _context5.t2 = _context5["catch"](8);
                              resolved = true;
                              reject(_context5.t2);

                            case 21:
                              window.removeEventListener("message", onEvent, false);

                            case 22:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5, null, [[8, 17]]);
                    }));
                  }, false);
                  var interval = setInterval(function () {
                    if (source.closed && !resolved) {
                      clearInterval(interval);
                      reject("user closed the window");
                    }
                  }, 1000);
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
  }]);

  return WaxEventSource;
}();

exports.WaxEventSource = WaxEventSource;